import React from "react";
import { Button, Card } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AccountUIActionTypes } from "src/common";

type AllProps = {
  handleAction: ActionHandlerFunction;
  request_user_id: string;
}

function AwaitConnectionComponent(props: AllProps) {
  const { handleAction, request_user_id } = props;

  function handleCancel() {
    handleAction({ actionType: AccountUIActionTypes.Destroy });
  };

  return <Card.Body>
    <h3 className="content-header">
      <i className="waiting"></i>Awaiting Connection&hellip;
    </h3>
    <div className="max-700">
      <h4>
        Waiting for <b>{request_user_id}</b> to establish a connection with you.
      </h4>
    </div>
    <Button variant="outline-primary" onClick={handleCancel}>
      Cancel
    </Button> 
  </Card.Body>;
}

export default React.memo(AwaitConnectionComponent);
